<template>
  <section
    id="admin-device-list"
    :dir="$functions.currentLangDirection()"
  >
    <b-card class="admin-page-mobile">
      <b-button
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-primary'"
        @click="addClick()"
      >
        <feather-icon
          icon="PlusIcon"
          size="22"
          class="align-text-top"
        /> افزودن
      </b-button>

      <b-button
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-success'"
        style="margin-right: 10px;"
        @click="goToStatistics()"
      >
        <feather-icon
          icon="BarChart2Icon"
          size="22"
          class="align-text-top"
        /> آمار
      </b-button>

      <b-button
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-info'"
        style="margin-right: 10px;"
        @click="goToMonitoring()"
      >
        <feather-icon
          icon="ActivityIcon"
          size="22"
          class="align-text-top"
        /> مانیتورینگ لحظه‌ای
      </b-button>

      <b-button
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-danger'"
        style="margin-right: 10px;"
        @click="showDisableExpiredModal()"
      >
        <feather-icon
          icon="AlertCircleIcon"
          size="22"
          class="align-text-top"
        /> غیرفعال‌سازی دستگاه‌های منقضی
      </b-button>

      <!-- Using the new download report button component -->
      <download-report-button
        button-text="دانلود گزارش"
        :filter="currentFilter"
        @download-success="onDownloadSuccess"
        @download-error="onDownloadError"
      />

      <b-button
        style="display: none"
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-primary'"
        @click="showModalExcel"
      >
        <feather-icon
          icon="PlusIcon"
          size="22"
          class="align-text-top"
        />
        افزودن از اکسل
      </b-button>

      <!-- Filter Badge -->
      <device-filter-badge
        :active-filter="currentFilter"
        @clear-filter="clearFilter"
      />

      <v-data-table
        v-bind="tableProps"
        :headers="headers"
        :items="desserts"
        :footer-props="footerProps"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('Search')"
            class="mx-4"
            style=""
          />
        </template>
        <template v-slot:item.expireTime="{ item }">
          <span
            v-if="item.expire===-1"
            style="color: red"
          >{{ item.expireTime }}</span>
          <span v-else>{{ item.expireTime }}</span>
          <v-icon
            style="color:rgb(92, 122, 238);padding: 4px;"
            :label="$t('Edit')"
            @click="onEditItem('modal-change-expireTime',item)"
          >
            mdi-calendar
          </v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <DeviceActionsMenu
            :device="item"
            :actions="actions"
            @toggle-status="onToggleStatus"
          />
        </template>
        <template v-slot:no-data>
          <v-btn
            variant="gradient-primary"
            @click="getAllDevices"
          >
            {{ $t('Update') }}
          </v-btn>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          <span class="footer-page-text">
            {{ pageStart }}-{{ pageStop }} از {{ itemsLength }}
          </span>
        </template>
      </v-data-table>

      <EditDeviceNameModal
        ref="editDeviceNameModal"
        :device="selectedDevice || {}"
        @save="emitChangeName"
      />

      <!-- modal change user -->
      <b-modal
        id="modal-change-user"
        ref="modal-change-user"
        cancel-variant="outline-secondary"
        :ok-title="$t('Save')"
        :cancel-title="$t('Close')"
        centered
        title="انتقال دستگاه به کاربر جدید"
      >

        <b-form>
          <!-- title -->
          <b-form-group
            label="کاربر فعلی"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="device.userId"
                required
                disabled
              >
                <option
                  v-for="item in userList"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="کاربر جدید"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <model-list-select
                v-model="userIdSelected"
                :list="userList"
                option-value="_id"
                :custom-text="optionDisplayText"
                placeholder="کاربران"
              />
            </b-input-group>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-user')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeUser()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>

      <!-- modal change reseller -->
      <b-modal
        id="modal-change-reseller"
        ref="modal-change-reseller"
        cancel-variant="outline-secondary"
        :ok-title="$t('Save')"
        :cancel-title="$t('Close')"
        centered
        title="انتقال دستگاه به نماینده جدید"
      >

        <b-form>
          <!-- title -->
          <b-form-group
            label="نماینده فعلی"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="device.resellerId"
                required
                disabled
              >
                <option
                  v-for="item in agentList"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="نماینده جدید"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="resellerIdSelected"
                required
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in agentList"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-reseller')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeReseller()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>

      <!-- modal change reseller -->
      <b-modal
        id="modal-change-model"
        ref="modal-change-model"
        cancel-variant="outline-secondary"
        :ok-title="$t('Save')"
        :cancel-title="$t('Close')"
        centered
        title="تغییر مدل دستگاه"
      >

        <b-form>
          <!-- title -->
          <b-form-group
            label="مدل فعلی"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="device.modelId"
                required
                disabled
              >
                <option
                  v-for="item in optionsModel"
                  :value="item._id"
                >
                  {{ item.title }} - {{ item.protocol }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label="مدل جدید"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="modelIdSelected"
                required
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in optionsModel"
                  :value="item._id"
                >
                  {{ item.title }} - {{ item.protocol }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-model')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeModel()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>
      <b-modal
        id="modal-change-expireTime"
        ref="modal-change-expireTime"
        cancel-variant="outline-secondary"
        :ok-title="$t('Save')"
        :cancel-title="$t('Close')"
        centered
        title="تغییر تاریخ اعتبار"
      >

        <b-form>
          <!-- title -->
          <b-form-group
            label="تاریخ اعتبار"
            label-for="vi-imei"
          />

          <date-picker
            v-model="device.expireTime"
            style="margin: 0 5px;"
            append-to="body"
          />
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-expireTime')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeModel()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>
      <!-- modal change reseller -->
      <b-modal
        id="modal-change-sim"
        ref="modal-change-sim"
        cancel-variant="outline-secondary"
        :ok-title="$t('Save')"
        :cancel-title="$t('Close')"
        centered
        title="تغییر سیمکارت دستگاه"
      >

        <b-form>
          <b-form-group
            label="شماره سیمکارت فعلی"
            label-for="v-Sim"
          >
            <b-form-input
              id="v-Sim"
              v-model="device.sim"
              class="numeric-input"
              maxlength="11"
              disabled
            />
          </b-form-group>
          <b-form-group
            label="شماره سیمکارت جدید"
            label-for="v-Sim"
          >
            <b-form-input
              id="v-Sim"
              v-model="simIdSelected"
              placeholder="09xxxxxxxxx"
              maxlength="11"
              class="numeric-input"
            />
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-sim')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeModel()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>

      <!-- Disable Expired Devices Modal -->
      <b-modal
        id="modal-disable-expired"
        ref="disableExpiredModal"
        title="غیرفعال‌سازی دستگاه‌های منقضی شده"
        centered
        size="lg"
        ok-title="بله، غیرفعال کن"
        cancel-title="انصراف"
        ok-variant="danger"
        @ok="handleDisableExpired"
      >
        <b-alert show variant="warning" class="mb-3">
          <h5>⚠️ هشدار مهم</h5>
          <p class="mb-0">این عملیات دستگاه‌هایی که تاریخ اعتبارشان گذشته است را غیرفعال می‌کند.</p>
        </b-alert>

        <!-- Limit Selection -->
        <b-form-group
          label="تعداد دستگاه‌های منقضی برای غیرفعال‌سازی:"
          label-for="disable-limit-select"
          class="mb-3"
        >
          <b-form-select
            id="disable-limit-select"
            v-model="disableLimit"
            :options="disableLimitOptions"
          ></b-form-select>
          <small class="text-muted">
            برای تست و کنترل بهتر، می‌توانید تعداد محدودی از دستگاه‌ها را انتخاب کنید
          </small>
        </b-form-group>

        <h6>تأثیرات غیرفعال‌سازی:</h6>
        <ul>
          <li>🚫 <strong>قطع دسترسی کاربر:</strong> کاربران نمی‌توانند دستگاه را در پنل مشاهده کنند</li>
          <li>📍 <strong>قطع ردیابی:</strong> موقعیت دستگاه دیگر بروزرسانی نمی‌شود</li>
          <li>🔔 <strong>قطع اعلان‌ها:</strong> هشدارها و نوتیفیکیشن‌ها ارسال نمی‌شود</li>
          <li>💾 <strong>حفظ اطلاعات:</strong> تاریخچه و داده‌های قبلی حفظ می‌شود</li>
          <li>🔄 <strong>قابل بازگشت:</strong> می‌توانید دستگاه را دوباره فعال کنید</li>
        </ul>

        <b-alert show variant="info" class="mt-3">
          <p class="mb-0"><strong>نکته:</strong> پس از غیرفعال‌سازی، یک گزارش کامل از دستگاه‌های غیرفعال شده نمایش داده خواهد شد.</p>
        </b-alert>
      </b-modal>

      <!-- Disable Report Modal -->
      <b-modal
        id="modal-disable-report"
        ref="disableReportModal"
        title="گزارش غیرفعال‌سازی دستگاه‌ها"
        centered
        size="xl"
        ok-only
        ok-title="بستن"
        ok-variant="primary"
      >
        <b-alert show variant="success" v-if="disableReport">
          <h5>✅ عملیات با موفقیت انجام شد</h5>
          <p class="mb-0">{{ disableReport.message }}</p>
          <p class="mb-0"><strong>تاریخ:</strong> {{ disableReport.log.persianDate }}</p>
        </b-alert>

        <!-- Summary Stats -->
        <b-row v-if="disableReport" class="mb-3">
          <b-col md="3">
            <b-card bg-variant="info" text-variant="white" class="text-center">
              <h3 class="mb-0">{{ disableReport.totalExpired }}</h3>
              <small>کل دستگاه‌های منقضی</small>
            </b-card>
          </b-col>
          <b-col md="3">
            <b-card bg-variant="success" text-variant="white" class="text-center">
              <h3 class="mb-0">{{ disableReport.totalDisabled }}</h3>
              <small>غیرفعال شده</small>
            </b-card>
          </b-col>
          <b-col md="3">
            <b-card bg-variant="warning" text-variant="white" class="text-center">
              <h3 class="mb-0">{{ disableReport.remainingExpired }}</h3>
              <small>باقی‌مانده</small>
            </b-card>
          </b-col>
          <b-col md="3">
            <b-card bg-variant="primary" text-variant="white" class="text-center">
              <h3 class="mb-0">{{ disableReport.limitApplied }}</h3>
              <small>محدودیت اعمال شده</small>
            </b-card>
          </b-col>
        </b-row>

        <div v-if="disableReport && disableReport.disabledDevices.length > 0">
          <h6>لیست دستگاه‌های غیرفعال شده ({{ disableReport.totalDisabled }} دستگاه):</h6>
          <b-table
            :items="disableReport.disabledDevices"
            :fields="reportFields"
            striped
            hover
            responsive
            small
          ></b-table>
        </div>

        <b-alert show variant="warning" v-if="disableReport && disableReport.remainingExpired > 0" class="mt-3">
          <p class="mb-0">⚠️ هنوز {{ disableReport.remainingExpired }} دستگاه منقضی دیگر باقی مانده است. می‌توانید دوباره این عملیات را اجرا کنید.</p>
        </b-alert>
      </b-modal>
    </b-card>

    <!-- modal login-->
    <b-modal
      id="modal-addExcel"
      ref="modal-addExcel"
      cancel-variant="outline-secondary"
      :ok-title="$t('Add')"
      :cancel-title="$t('Close')"
      centered
      title="افزودن دسته جمعی"
    >
      <validation-observer ref="Validation">
        <b-form>
          <input
            type="file"
            @change="onFileChange"
          >
          <b-form-group
            label="نمایندگی:"
            label-for="vi-port"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="xmlDevice.resellerId"
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in optionsAgent"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }} - {{ item.mobile }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="مدل"
            label-for="vi-protocol"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="xmlDevice.modelId"
                required
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in optionsModel"
                  :value="item._id"
                >
                  {{ item.title }} - {{ item.protocol }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label="سرور"
            label-for="vi-server"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="xmlDevice.serverId"
                required
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in serverList"
                  :value="item._id"
                >
                  {{ item.title }} {{ item.url }}:{{ item.port }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label="اشتراک"
            label-for="vi-server"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="xmlDevice.plan"
                required
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  {{ $t('Select') }}
                </option>
                <option
                  v-for="item in devicePlan"
                  :value="item.value"
                >
                  {{ item.title }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-form>
      </validation-observer>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModalExcel"
        >
          بستن
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="modalAddXlm()"
        >
          ذخیره
        </b-button>
      </template>
    </b-modal>
  </section>

</template>
<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BCard, BForm, BCardBody, BButton, BInputGroup, BInputGroupPrepend, BFormCheckbox, BFormSelect, BFormDatalist, BAlert, BTable,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Vue from 'vue'
import readXlsxFile from 'read-excel-file'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import { ModelListSelect } from 'vue-search-select'
// eslint-disable-next-line import/no-cycle
import router from '@/router'
import Device from '@/models/device'
// eslint-disable-next-line import/no-named-as-default
import DeviceService from '@/services/device.service'
import Model from '@/models/model'
import ModelService from '@/services/model.service'
import customerService from '@/services/customer.service'
import ServerService from '@/services/server.service'

import BreadcrumbMobile from '@/layouts/breadcrumb.vue'
import Config from '../../../../config'
import 'vue-search-select/dist/VueSearchSelect.css'
// eslint-disable-next-line import/order
import EditDeviceNameModal from '@/views/admin/device/EditDeviceNameModal.vue'
import DownloadReportButton from '@/views/admin/device//DownloadReportButton.vue' // Adjust path as needed
import DeviceFilterBadge from '@/views/admin/device/DeviceFilterBadge.vue'
import DeviceActionsMenu from '@/views/admin/device/DeviceActionsMenu.vue'
import { applyDeviceFilter } from '@/utils/deviceFilters'

export default {
  components: {
    DownloadReportButton,
    ModelListSelect,
    EditDeviceNameModal,
    DeviceFilterBadge,
    DeviceActionsMenu,
    BreadcrumbMobile,
    BRow,
    BCard,
    BCardBody,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BFormCheckbox,
    BFormSelect,
    BFormDatalist,
    BAlert,
    BTable,
    ValidationProvider,
    ValidationObserver,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      search: '',
      desserts: [],
      allDevices: [], // Store all devices before filtering
      currentFilter: null, // Current filter type
      xmlImei: [],
      xmlDevice: [],
      devicePlan: [{ value: 1, title: 'یک ماهه' }, { value: 6, title: 'شش ماهه' }, { value: 12, title: 'یک ساله' }, { value: 24, title: 'دو ساله' }, { value: 60, title: 'پنج ساله' }],
      model: new Model('', '', '', ''),
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      options: [],
      optionsModel: [],
      optionsAgent: [],
      agentList: [],
      userList: [],
      serverList: [],
      userIdSelected: '',
      resellerIdSelected: '',
      modelIdSelected: '',
      simIdSelected: '',
      selectedAgent: '',
      isMobile: Vue.prototype.$functions.isMobile(),
      selectedDevice: {},
      disableReport: null,
      disableLimit: null, // null means no limit (all)
      disableLimitOptions: [
        { value: null, text: 'همه دستگاه‌های منقضی' },
        { value: 20, text: '20 تای آخر (تست)' },
        { value: 50, text: '50 تای آخر' },
        { value: 100, text: '100 تای آخر' },
        { value: 200, text: '200 تای آخر' },
        { value: 500, text: '500 تای آخر' }
      ],
      reportFields: [
        { key: 'imei', label: 'IMEI' },
        { key: 'title', label: 'عنوان دستگاه' },
        { key: 'userName', label: 'نام کاربر' },
        { key: 'userMobile', label: 'موبایل' },
        { key: 'expireTime', label: 'تاریخ انقضا' },
        { key: 'disabledAt', label: 'زمان غیرفعال‌سازی' }
      ],
    }
  },
  computed: {
    tableProps() {
      return {
        dark: this.$functions.isMobile(),
        search: this.search,
        mobileBreakpoint: 0,
        loading: true,
        loadingText: 'درحال بارگذاری لطفا صببر کنید...',
        itemsPerPage: 50,
      }
    },
    footerProps() {
      return {
        'items-per-page-text': 'تعداد ردیف در هر صفحه:',
        'items-per-page-options': [15, 50, 100, 150, 200, 300,400],
        'show-first-last-page': true,
        'first-icon': 'mdi-chevron-double-right',
        'last-icon': 'mdi-chevron-double-left',
        'prev-icon': 'mdi-chevron-right',
        'next-icon': 'mdi-chevron-left',
      }
    },
    actions() {
      return [
        {
          title: 'ویرایش نام',
          icon: 'mdi-pencil',
          color: 'rgb(50, 115, 220)',
          handler: item => this.openEditNameModal(item), // استفاده از تابع اصلاح‌شده
        },
        {
          title: 'ارسال تنظیمات', icon: 'mdi-android-messages', color: 'rgb(137, 41, 191)', handler: this.onConfigure,
        },
        {
          title: 'انتقال به کاربر دیگر', icon: 'mdi-account-switch-outline', color: '#296bbf', handler: item => this.onEditItem('modal-change-user', item),
        },
        {
          title: 'تغییر نماینده', icon: 'mdi-account-tie-hat', color: 'rgb(191, 41, 55)', handler: item => this.onEditItem('modal-change-reseller', item),
        },
        {
          title: 'تغییر مدل', icon: 'mdi-usb-flash-drive', color: 'rgb(88, 191, 41)', handler: item => this.onEditItem('modal-change-model', item),
        },
        {
          title: 'تغییر سیمکارت', icon: 'mdi-sim-outline', color: 'rgb(202, 128, 32)', handler: item => this.onEditItem('modal-change-sim', item),
        },
        {
          title: 'حذف', icon: 'mdi-delete', color: 'rgb(138, 131, 131)', handler: this.onDeleteItem,
        },
      ]
    },
    headers() {
      return [
        { text: 'دسته بندی', value: 'categoryName' },
        { text: 'عنوان', value: 'title' },
        { text: this.$t('Name'), value: 'userName' },
        { text: 'موبایل کاربر', value: 'userMobile' },
        { text: this.$t('Reseller'), value: 'resellerName' },
        { text: this.$t('Device model'), value: 'model' },
        { text: this.$t('Sim'), value: 'sim' },
        { text: 'imei', value: 'imei' },
        { text: this.$t('Expire date'), value: 'expireTime' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Active date'), value: 'activeTime' },
        { text: this.$t('Creation date'), value: 'creationDate' },
        { text: this.$t('Modification date'), value: 'modificationTime' },
        { text: this.$t('Operations'), value: 'actions', sortable: false },
      ]
    },
  },
  async created() {
    this.$vuetify.rtl = true
    // Check for filter parameter from route query
    if (this.$route.query.filter) {
      this.currentFilter = this.$route.query.filter
    }
    this.getAllDevices()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
    },
  },
  async mounted() {
    try {
      ModelService.getList().then(
        res => {
          this.optionsModel = []
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.optionsModel = res.result.data
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
    try {
      this.agentList = []
      await customerService.getAll({ type: 1 }).then(
        res => {
          if (res.status === 'success') {
            // console.log(res.result.data)
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              /// this.agentList = res.result.data
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                this.agentList.push(res.result.data[i])
              }
            }
          }
        },
      )
      await customerService.getAll({ type: 2 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                this.agentList.push(res.result.data[i])
              }
            }
          }
        },
      )
      this.userList = []
      await customerService.getAll({ type: -1 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.userList = res.result.data
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
    try {
      ServerService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.serverList = res.result.data
            } else {
              this.serverList = []
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
  },
  methods: {

    // Optional event handlers for the download button
    onDownloadSuccess() {
      // console.log('Download completed successfully')
      // You can add additional logic here if needed
    },

    onDownloadError(error) {
      // console.error('Download failed:', error)
      // You can add additional error handling here if needed
    },

    optionDisplayText(animation) {
      return `${animation.name} ${animation.family} - ${animation.mobile}`
    },
    onFileChange(event) {
      const filterImei = ['imei', 'Imei', 'IMEI', 'سریال']
      const filterSim = ['sim', 'Sim', 'سیمکارت']
      const filterMobile = ['mobile', 'Mobile', 'موبایل']
      const filterName = ['name', 'Name', 'نام']
      const filterFamily = ['family', 'Family', 'نام خانوادگی']
      const xlsxfile = event.target.files ? event.target.files[0] : null
      readXlsxFile(xlsxfile).then(rows => {
        let imeiIndex = -1
        let simIndex = -1
        let mobileIndex = -1
        let nameIndex = -1
        let familyIndex = -1
        this.xmlImei = []
        rows.forEach((element, index) => {
          if (index === 0) {
            element.forEach((field, index2) => {
              if (filterImei.includes(field)) {
                imeiIndex = index2
              }
              if (filterSim.includes(field)) {
                simIndex = index2
              }
              if (filterMobile.includes(field)) {
                mobileIndex = index2
              }
              if (filterName.includes(field)) {
                nameIndex = index2
              }
              if (filterFamily.includes(field)) {
                familyIndex = index2
              }
            })
          } else {
            const temp = {}
            if (imeiIndex !== -1) {
              temp.imei = element[imeiIndex].toString()
            }
            if (simIndex !== -1) {
              temp.sim = element[simIndex]
            }
            if (mobileIndex !== -1) {
              temp.mobile = element[mobileIndex]
            }
            if (mobileIndex !== -1) {
              temp.name = element[nameIndex]
            }
            if (mobileIndex !== -1) {
              temp.family = element[familyIndex]
            }
            this.xmlImei.push(temp)
          }
        })

        // console.log('rows:', this.xmlImei)
      })
    },
    initializeOption() {
      try {
        customerService.getAll({ type: 1 }).then(
          res => {
            this.optionsAgent = []
            if (res.status === 'success') {
              if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
                this.optionsAgent = res.result.data
              } else {
                this.optionsAgent = []
              }
            }
          },
        )
      } catch (err) {
        // console.log(err)
      }
    },
    getAllDevices() {
      this.desserts = []
      this.allDevices = []
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }
      const alan2 = new Date().toLocaleDateString('fa-IR', options).replaceAll('/', '')
      const alan = Vue.prototype.$functions.toEnNumbers(alan2)
      DeviceService.getAll().then(
        res => {
          if (res.status === 'success') {
            // console.log(res.result.data)
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                const temp = res.result.data[i]
                temp.model = temp.modelId.title
                temp.status = temp.disabled ? 'غیرفعال' : 'فعال'
                temp.userName = temp.userId !== undefined ? `${temp.userId.name} ${temp.userId.family}` : ''
                temp.userMobile = temp.userId !== undefined ? `${temp.userId.mobile}` : ''
                temp.resellerName = `${temp.resellerId.name} ${temp.resellerId.family}`
                temp.categoryName = ''
                for (let j = 0; j <= Config.carTypes.length - 1; j += 1) {
                  const carType = Config.carTypes[j]
                  if (carType.value === temp.category) {
                    if (typeof Config.carTypes[temp.category] === 'undefined') {
                      temp.categoryName = Config.carTypes[0].text
                    } else {
                      temp.categoryName = Config.carTypes[temp.category].text
                    }
                    break
                  }
                }
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                if (temp.activeTime) {
                  temp.activeTime = new Date(temp.activeTime * 1000).toLocaleDateString('fa-IR')
                }
                if (temp.modificationTime) {
                  temp.modificationTime = new Date(temp.modificationTime * 1000).toLocaleDateString('fa-IR')
                }
                temp.expire = 1
                if (typeof temp.expireTime !== 'undefined') {
                  if (temp.expireTime !== null) {
                    const exp = temp.expireTime.replaceAll('/', '')

                    if (alan > exp) {
                      temp.expire = -1
                    }
                  }

                  // temp.expireTime = temp.expireTime
                } else {
                  temp.expireTime = 0
                }
                this.allDevices.push(temp)
              }
              // Apply filter after loading all devices
              this.desserts = applyDeviceFilter(this.allDevices, this.currentFilter)
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ name: 'admin-device-add' })
    },
    goToStatistics() {
      router.push({ name: 'admin-device-statistics' })
    },
    goToMonitoring() {
      router.push({ name: 'admin-server-monitoring' })
    },
    modalAddXlm() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.addXlm({
        list: this.xmlImei,
        resellerId: this.xmlDevice.resellerId,
        modelId: this.xmlDevice.modelId,
        serverId: this.xmlDevice.serverId,
        plan: this.xmlDevice.plan,
      }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-addExcel')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeUser() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeUser({ imei: this.device.imei, resellerId: this.device.resellerId, customerId: this.userIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-change-user')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeReseller() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeReseller({ imei: parseInt(this.device.imei), customerId: this.device.userId, resellerId: this.resellerIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-change-reseller')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeModel() {
      // console.log(this.device.expireTime)
      if (this.simIdSelected === '') { this.simIdSelected = this.device.sim }
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeModel({
        imei: parseInt(this.device.imei), modelId: this.device.modelId, sim: this.simIdSelected, expireTime: this.device.expireTime,
      }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-change-model')
            this.$bvModal.hide('modal-change-expireTime')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeSim() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeModel({ imei: parseInt(this.device.imei), sim: this.device.sim, modelId: this.modelIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-change-sim')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)

      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        DeviceService.delete({
          // eslint-disable-next-line no-underscore-dangle
          id: this.desserts[index]._id,
          imei: this.desserts[index].imei,
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: res.result,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
      // Todo: Make this delete item from store
      // eslint-disable-next-line no-underscore-dangle
    },
    openEditNameModal(item) {
      if (!item) return // بررسی اینکه مقدار item معتبر است

      // مقداردهی `selectedDevice`
      // console.log(item)
      this.selectedDevice = { ...item, userName: item.userName } // مقداردهی userName
      // console.log('📌 مقدار انتخاب‌شده:', this.selectedDevice)
      // console.log(this.selectedDevice)

      this.$nextTick(() => {
        // بررسی و نمایش مدال فقط در صورت وجود ریفرنس
        if (this.$refs.editDeviceNameModal) {
          this.$refs.editDeviceNameModal.$bvModal.show('modal-change-name')
        } else {
          // console.error("⚠️ Reference for 'modal-change-name' is not available")
        }
      })
    },
    onEditItem(select, item) {
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      this.device._id = this.desserts[index]._id.toString()

      if (select !== 'modal-change-reseller') {
        // console.log(select)
        // eslint-disable-next-line no-underscore-dangle
        this.device.userId = this.desserts[index].userId._id.toString()
        this.device.sim = this.desserts[index].sim.toString()
      }

      if (select === 'modal-change-name') {
        this.selectedDevice = item ? { ...item } : {} // جلوگیری از مقدار null
        this.$bvModal.show('modal-change-name')
      }

      this.device.imei = this.desserts[index].imei
      // eslint-disable-next-line no-underscore-dangle
      this.device.modelId = this.desserts[index].modelId._id.toString()
      // eslint-disable-next-line no-underscore-dangle
      this.device.resellerId = this.desserts[index].resellerId._id.toString()
      // eslint-disable-next-line no-underscore-dangle
      this.device.serverId = this.desserts[index].serverId._id.toString()
      this.device.disabled = this.desserts[index].disabled.toString()

      this.device.expireTime = this.desserts[index].expireTime.toString()

      this.$refs[select].show()
    },
    onConfigure(item) {
      const index = this.desserts.indexOf(item)
      this.device.imei = this.desserts[index].imei
      this.device.sim = this.desserts[index].sim.toString()

      if (this.device.imei && this.device.sim) {
        DeviceService.configure(this.device)
          .then(
            res => {
              if (res.status === 'error') {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'خطای تنظیم سیمکارت',
                    text: res.message,
                    icon: 'XIcon',
                    variant: 'danger',
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'دستگاه با موفقیت تنظیم شد.',
                    icon: 'EditIcon',
                    variant: 'success',
                  },
                })
              }
            },
          )
      }
    },
    modalChangeName(newName) {
      DeviceService.changeName({
        imei: this.selectedDevice.imei,
        newName,
      }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
          }
        },
        error => {
          this.message = error.response?.data || error.message || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا در تغییر نام',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    emitChangeName() {
      // this.$toast.success('نام دستگاه با موفقیت تغییر کرد.')
      this.getAllDevices() // دریافت مجدد داده‌ها برای به‌روزرسانی جدول
    },
    showModalExcel() {
      this.initializeOption()
      this.$refs['modal-addExcel'].show()
    },
    hideModalExcel() {
      this.$refs['modal-addExcel'].hide()
    },
    clearFilter() {
      this.currentFilter = null
      this.$router.push({ name: 'admin-device-all' })
      this.desserts = [...this.allDevices]
    },
    showDisableExpiredModal() {
      this.disableLimit = 20 // Default to 20 for testing
      this.$refs.disableExpiredModal.show()
    },
    async handleDisableExpired() {
      try {
        const limitText = this.disableLimit ? `${this.disableLimit} دستگاه` : 'همه دستگاه‌های منقضی'
        this.$bvToast.toast(`در حال غیرفعال‌سازی ${limitText}...`, {
          title: 'لطفاً صبر کنید',
          variant: 'info',
          solid: true
        })

        const response = await DeviceService.disableExpiredDevices(this.disableLimit)

        if (response.status === 'success') {
          this.disableReport = response.result
          this.$refs.disableReportModal.show()
          this.loadItems() // Refresh the list
        }
      } catch (error) {
        this.$bvToast.toast('خطا در غیرفعال‌سازی دستگاه‌ها', {
          title: 'خطا',
          variant: 'danger',
          solid: true
        })
      }
    },
    loadItems() {
      this.getAllDevices()
    },
    async onToggleStatus(item) {
      const newStatus = !item.disabled
      const actionText = newStatus ? 'غیرفعال' : 'فعال'

      // eslint-disable-next-line no-restricted-globals
      if (!confirm(`آیا مطمئنید که می‌خواهید دستگاه را ${actionText} کنید؟`)) {
        return
      }

      try {
        const response = await DeviceService.toggleStatus({
          imei: item.imei,
          disabled: newStatus
        })

        if (response.status === 'success') {
          // Update the item locally
          const index = this.desserts.findIndex(d => d.imei === item.imei)
          if (index !== -1) {
            this.desserts[index].disabled = newStatus
            this.desserts[index].status = newStatus ? 'غیرفعال' : 'فعال'
          }

          // Also update in allDevices
          const allIndex = this.allDevices.findIndex(d => d.imei === item.imei)
          if (allIndex !== -1) {
            this.allDevices[allIndex].disabled = newStatus
            this.allDevices[allIndex].status = newStatus ? 'غیرفعال' : 'فعال'
          }

          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.result.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: response.result || 'خطا در تغییر وضعیت دستگاه',
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا',
            text: error.message || 'خطا در ارتباط با سرور',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>
<style>
#admin-device-list .v-icon.v-icon{
  font-size: 16px;
}
#modal-change-expireTime___BV_modal_outer_{
  z-index: 100 !important;
}

/* استایل هدر ثابت */
thead th {
  position: sticky;
  top: 0;
  background-color: #ebebeb; /* برای جلوگیری از تداخل رنگ با محتوای جدول */
  z-index: 100; /* برای اطمینان از اینکه هدر روی سایر محتواها قرار گیرد */
  border: 1px solid #bcbcbc;
}
[dir] thead th {
  background-color: #ebebeb;
  border: 1px solid #bcbcbc !important;
}

/* استایل برای جدول که اسکرول عمودی داشته باشد */
table {
  width: 100%;
  border-collapse: collapse;
  overflow-y: auto;
  display: block; /* برای فعال شدن اسکرول */
  max-height:400px; /* حداکثر ارتفاع برای ایجاد اسکرول */
}

/* بهبود استایل pagination */
.v-data-footer {
  direction: rtl !important;
  padding: 16px 8px;
  font-size: 14px;
}

.v-data-footer__select,
.v-data-footer__pagination {
  direction: rtl !important;
}

.footer-page-text {
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
  padding: 0 12px;
}

/* بهبود استایل دکمه‌های pagination */
.v-data-footer .v-btn {
  margin: 0 4px;
}

.v-data-footer__icons-before,
.v-data-footer__icons-after {
  margin: 0 8px;
}

</style>
